import { FC } from 'react'

import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductInfoModal } from 'featureSliced/widgets/Modals/ProductInfoModal'

type ProductInfoInlineProps = {
  product: IProduct
}

export const ProductInfoInline: FC<ProductInfoInlineProps> = ({ product }) => {
  if (!product.hasProductInfo) return null

  return (
    <ProductInfoModal categoryId={product.categoryId} productId={product.id} />
  )
}
